import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'antd'
import Notice from './Notice'
import {errorMessage, errorStatus} from '../../helpers/apiError'

/**
 * Trạng thái lỗi tải dữ liệu. Không màn hình nào được để trắng và không màn hình nào được hiện
 * bảng rỗng khi thực chất là lỗi (UI-07 · G-02 · M17 §4.7): người dùng sẽ tưởng là không có dữ
 * liệu và đi hỏi sai người.
 *
 * `503` được tách riêng vì bảy cổng đọc FAC/FFM trong `facPorts.ts` hiện **ném 503 kèm thông báo
 * "chưa đấu nối"** thay vì trả rỗng. Trả rỗng làm báo cáo hiện bảng trắng như thể "không có hàng"
 * — đúng cái M17 §8.3 và M18 BR-D10 cấm.
 */
function LoadError({error, message, onRetry}) {
    // Lỗi đã được interceptor trải phẳng, đọc qua helper — xem ghi chú ở helpers/apiError.js.
    const status = errorStatus(error)
    const serviceMessage = errorMessage(error)

    if (status === 403) {
        return <Notice level="error">Bạn không có quyền truy cập chức năng này</Notice>
    }

    if (status === 503) {
        return (
            <Notice level="error">
                <div>Nguồn dữ liệu chưa được đấu nối nên chưa chạy được báo cáo.</div>
                <div className="VcNoticeSub">
                    {serviceMessage || 'Cổng đọc dữ liệu FAC/FFM của service chưa có adapter.'}
                    {' '}Người xử lý: Dev Lead. Đây không phải trạng thái “không có hàng”.
                </div>
            </Notice>
        )
    }

    return (
        <Notice level="error">
            <div>{serviceMessage || message}</div>
            {onRetry && (
                <Button size="small" className="mt-2" onClick={onRetry}>Thử lại</Button>
            )}
        </Notice>
    )
}

LoadError.propTypes = {
    error: PropTypes.object,
    message: PropTypes.string,
    onRetry: PropTypes.func,
}

LoadError.defaultProps = {
    message: 'Không tải được dữ liệu. Vui lòng thử lại',
}

export default LoadError
